import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button
} from '@mui/material';

import OrderSummaries from '../OrderSummaries';
import PrescriptionSummary from '../Summaries/PrescriptionSummary';

import {
  assessmentActionsSx,
  assessmentButtonStyles,
  assessmentWrapperSx
} from './SoapEntryStyles';

const AssessmentActions = ({
  actions,
  signedPrescription,
  labOrder,
  imagingOrder,
  physicianOrder,
  onEditPrescription,
  onEditLab,
  onEditImaging,
  onEditPhysician
}) => {
  return (
    <Box sx={assessmentWrapperSx}>
      <Box sx={assessmentActionsSx}>
        {actions.map(item => (
          <Button
            key={item.label}
            variant="outlined"
            size="small"
            onClick={item.onClick}
            sx={{
              ...assessmentButtonStyles.common,
              ...assessmentButtonStyles[item.type]
            }}>
            {item.label}
          </Button>
        ))}
      </Box>

      {signedPrescription && (
        <PrescriptionSummary
          prescription={signedPrescription}
          onEdit={onEditPrescription}
        />
      )}

      <OrderSummaries
        labOrder={labOrder}
        imagingOrder={imagingOrder}
        physicianOrder={physicianOrder}
        onEditLab={onEditLab}
        onEditImaging={onEditImaging}
        onEditPhysician={onEditPhysician}
      />
    </Box>
  );
};

AssessmentActions.propTypes = {
  actions: PropTypes.array.isRequired,
  signedPrescription: PropTypes.object,
  labOrder: PropTypes.object,
  imagingOrder: PropTypes.object,
  physicianOrder: PropTypes.object,
  onEditPrescription: PropTypes.func,
  onEditLab: PropTypes.func,
  onEditImaging: PropTypes.func,
  onEditPhysician: PropTypes.func
};

export default AssessmentActions;